/**
 * Converts configuration values from strings to their appropriate types.
 * Handles string to boolean, string to number, arrays, and nested objects.
 */
export const parseStringValue = <T>(value?: unknown): T => {
  if (value === undefined || value === null) {
    return value as T;
  }

  // Handle string to boolean conversion
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') return true as T;
    if (value.toLowerCase() === 'false') return false as T;

    // Handle string to number conversion
    const num = Number(value);
    if (!Number.isNaN(num) && value.trim() !== '') {
      return num as T;
    }
  }

  // Handle arrays
  if (Array.isArray(value)) {
    return value.map(item => parseStringValue(item)) as T;
  }

  // Handle nested objects
  if (typeof value === 'object') {
    const converted: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value)) {
      converted[key] = parseStringValue(val);
    }
    return converted as T;
  }

  return value as T;
};
